"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { forwardRef, useId } from "react";
import ErrorMessage from "../ErrorMessage";
import InfoIcon from "../InfoIcon";
import styles from "./TextField.module.css";
import { TextFieldProps } from "./types";
const TextField = forwardRef<HTMLInputElement & HTMLTextAreaElement, TextFieldProps>(function TextField(t0, ref) {
  const $ = _c(69);
  let as;
  let className;
  let disabled;
  let errorMessage;
  let hint;
  let info;
  let infoPlacement;
  let inverted;
  let label;
  let onChange;
  let onNumberChange;
  let prefix;
  let props;
  let size;
  let suffix;
  let t1;
  let t2;
  let t3;
  let t4;
  let thousandSeparatorEnabled;
  let variant;
  if ($[0] !== t0) {
    ({
      textarea: t1,
      thousandSeparatorEnabled,
      thousandSeparatorLocale: t2,
      label,
      errorMessage,
      type: t3,
      inverted,
      onChange,
      onNumberChange,
      className,
      variant,
      suffix,
      prefix,
      size,
      disabled,
      info,
      hint,
      infoPlacement,
      as,
      fitContent: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = as;
    $[2] = className;
    $[3] = disabled;
    $[4] = errorMessage;
    $[5] = hint;
    $[6] = info;
    $[7] = infoPlacement;
    $[8] = inverted;
    $[9] = label;
    $[10] = onChange;
    $[11] = onNumberChange;
    $[12] = prefix;
    $[13] = props;
    $[14] = size;
    $[15] = suffix;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = thousandSeparatorEnabled;
    $[21] = variant;
  } else {
    as = $[1];
    className = $[2];
    disabled = $[3];
    errorMessage = $[4];
    hint = $[5];
    info = $[6];
    infoPlacement = $[7];
    inverted = $[8];
    label = $[9];
    onChange = $[10];
    onNumberChange = $[11];
    prefix = $[12];
    props = $[13];
    size = $[14];
    suffix = $[15];
    t1 = $[16];
    t2 = $[17];
    t3 = $[18];
    t4 = $[19];
    thousandSeparatorEnabled = $[20];
    variant = $[21];
  }
  const textarea = t1 === undefined ? false : t1;
  const thousandSeparatorLocale = t2 === undefined ? "de-DE" : t2;
  const type = t3 === undefined ? "text" : t3;
  const fitContent = t4 === undefined ? false : t4;
  const genId = useId();
  const id = props.id || genId;
  size = size || "md";
  let t10;
  let t11;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[22] !== as || $[23] !== className || $[24] !== disabled || $[25] !== errorMessage || $[26] !== fitContent || $[27] !== id || $[28] !== info || $[29] !== infoPlacement || $[30] !== inverted || $[31] !== label || $[32] !== onChange || $[33] !== onNumberChange || $[34] !== prefix || $[35] !== props || $[36] !== ref || $[37] !== size || $[38] !== suffix || $[39] !== textarea || $[40] !== thousandSeparatorEnabled || $[41] !== thousandSeparatorLocale || $[42] !== type || $[43] !== variant) {
    const shared = {
      container: clsx("border transition-colors ease-out flex items-center", {
        "text-button-1 m:text-body-2 rounded-s": size === "md",
        "text-app-button-1 m:text-app-body-2 rounded-xs": size === "sm",
        "cursor-not-allowed": disabled,
        "border-neutral-425 hover:border-neutral-425 text-neutral-675": disabled && inverted,
        "border-neutral-50 hover:border-neutral-50 text-neutral-150": disabled && !inverted
      }),
      input: clsx("w-full peer resize-y focus:outline-none disabled:outline-none disabled:cursor-not-allowed text-inherit bg-[inherit]", {
        "field-sizing-content": fitContent,
        "px-s py-[11px] rounded-s": size === "md",
        "px-3xs py-[7px] rounded-xs": size === "sm"
      })
    };
    const variants = {
      normal: {
        title: "text-neutral-675",
        container: clsx("border-neutral-50 text-neutral-575 hover:border-neutral-100 focus-within:border-neutral-100", {
          "bg-neutral-0": !disabled,
          "bg-neutral-12": disabled
        }),
        input: "placeholder:text-neutral-150",
        suffix: "text-neutral-150"
      },
      inverted: {
        title: "text-neutral-0",
        container: "bg-cadet-900 border-neutral-425 text-neutral-0 hover:border-neutral-100 focus-within:border-neutral-100",
        input: "placeholder:text-neutral-150 bg-cadet-900",
        suffix: ""
      },
      primary: {
        title: "text-neutral-0",
        container: "bg-primary-800 border-neutral-0 text-neutral-0 focus-within:border-neutral-100",
        input: "placeholder:text-neutral-0/60 placeholder:text-body-2 bg-primary-800 hover:bg-primary-850 transition-all",
        suffix: ""
      },
      cadet: {
        title: "text-neutral-0",
        container: "bg-cadet-850 border-neutral-0 text-neutral-0 focus-within:border-neutral-100",
        input: "placeholder:text-neutral-0/60 placeholder:text-body-2 bg-cadet-850 hover:bg-cadet-900 transition-all",
        suffix: ""
      },
      neutral: {
        title: "text-neutral-675",
        container: "bg-neutral-12 border-neutral-12 text-neutral-675 focus-within:border-neutral-100",
        input: "placeholder:text-neutral-575/60",
        suffix: ""
      }
    };
    const variantClasses = inverted ? variants.inverted : variant ? variants[variant] : variants.normal;
    const Input = as || "input";
    t9 = `${id}-container`;
    if ($[51] !== className) {
      t10 = clsx("w-full", className);
      $[51] = className;
      $[52] = t10;
    } else {
      t10 = $[52];
    }
    t11 = label && <label htmlFor={id} className={clsx("flex items-center gap-2xs mb-xs", {
      "text-title-1": size === "md",
      "text-app-title-1": size === "sm"
    }, variantClasses.title)}>{label}{!!info && <InfoIcon placement={infoPlacement}>{info}</InfoIcon>}</label>;
    t5 = clsx(shared.container, variantClasses.container);
    t6 = prefix && <div className={clsx("transition-all ml-s flex items-center", variantClasses.suffix, {
      "text-error-700": errorMessage
    })}>{prefix}</div>;
    t7 = textarea ? <textarea aria-invalid={!!errorMessage} id={id} ref={ref} {...props} onChange={onChange} className={clsx(shared.input, variantClasses.input)} /> : <Input aria-invalid={!!errorMessage} id={id} type={thousandSeparatorEnabled ? "text" : type} ref={ref} disabled={disabled} {...props} className={clsx(shared.input, variantClasses.input, styles.input)} onChange={e => {
      if (thousandSeparatorEnabled) {
        const pristine = e.target.value.replace(/[^\d]/g, "");
        if (pristine.length > 0) {
          e.target.value = parseInt(pristine).toLocaleString(thousandSeparatorLocale);
          onNumberChange?.(parseInt(pristine));
        } else {
          e.target.value = "";
          onNumberChange?.(0);
        }
      } else {
        if (e.target.value) {
          onNumberChange?.(parseInt(e.target.value));
        } else {
          onNumberChange?.(0);
        }
      }
      onChange?.(e);
    }} />;
    t8 = suffix && <div className={clsx("transition-all flex items-center", variantClasses.suffix, {
      "text-error-700": errorMessage,
      "mr-s": size === "md",
      "mr-3xs": size === "sm"
    })}>{suffix}</div>;
    $[22] = as;
    $[23] = className;
    $[24] = disabled;
    $[25] = errorMessage;
    $[26] = fitContent;
    $[27] = id;
    $[28] = info;
    $[29] = infoPlacement;
    $[30] = inverted;
    $[31] = label;
    $[32] = onChange;
    $[33] = onNumberChange;
    $[34] = prefix;
    $[35] = props;
    $[36] = ref;
    $[37] = size;
    $[38] = suffix;
    $[39] = textarea;
    $[40] = thousandSeparatorEnabled;
    $[41] = thousandSeparatorLocale;
    $[42] = type;
    $[43] = variant;
    $[44] = t10;
    $[45] = t11;
    $[46] = t5;
    $[47] = t6;
    $[48] = t7;
    $[49] = t8;
    $[50] = t9;
  } else {
    t10 = $[44];
    t11 = $[45];
    t5 = $[46];
    t6 = $[47];
    t7 = $[48];
    t8 = $[49];
    t9 = $[50];
  }
  let t12;
  if ($[53] !== t5 || $[54] !== t6 || $[55] !== t7 || $[56] !== t8) {
    t12 = <div className={t5}>{t6}{t7}{t8}</div>;
    $[53] = t5;
    $[54] = t6;
    $[55] = t7;
    $[56] = t8;
    $[57] = t12;
  } else {
    t12 = $[57];
  }
  let t13;
  if ($[58] !== hint) {
    t13 = hint && <p className="text-title-1 text-neutral-675/60 mt-xs">{hint}</p>;
    $[58] = hint;
    $[59] = t13;
  } else {
    t13 = $[59];
  }
  let t14;
  if ($[60] !== errorMessage) {
    t14 = errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>;
    $[60] = errorMessage;
    $[61] = t14;
  } else {
    t14 = $[61];
  }
  let t15;
  if ($[62] !== t10 || $[63] !== t11 || $[64] !== t12 || $[65] !== t13 || $[66] !== t14 || $[67] !== t9) {
    t15 = <div id={t9} className={t10}>{t11}{t12}{t13}{t14}</div>;
    $[62] = t10;
    $[63] = t11;
    $[64] = t12;
    $[65] = t13;
    $[66] = t14;
    $[67] = t9;
    $[68] = t15;
  } else {
    t15 = $[68];
  }
  return t15;
});
export default TextField;